import React from "react";
import ProductCategory from "../../productcategory2";
import SEO from "../../seo";

export default function LuxuryCollectionPage() {
  const data = {
    categoryName: "Luxury Collection",
    description:
      "Craftsmanship and luxury meet technology for a grandeur collection of mattresses by Eclipse. The new blend of premium and comfort with advanced memory foam, we have looked into every detail of sleep science in this collection. Made with plush fabric and premium border designs, the collection is heaven for a sleeper’s body.",

    benefits: [
      "Premium range for discerning sleepers",
      "Crafted with finest fabrics & materials",
      "Luxe aesthetic for luxurious homes",
      "10 year warranty",
      "Excellent sleep health through patented technologies",
    ],
    products: [
      {
        img: "https://eclipsemattress.in/wp-content/uploads/2020/01/Ortho-visco_PNG.png",
        name: "ORTHO VISCO LX",
        link: "/luxury-collection/ortho-visco-lx/",
        startingAt: "₹21,199",
      },
      {
        img: "https://eclipsemattress.in/wp-content/uploads/2021/06/1000X667-cover-1.png",
        name: "ORTHO LATEX LX",
        link: "/luxury-collection/ortho-latex-lx/",
        startingAt: "₹19,199",
      },
      {
        img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Posture-comfort-PT.png",
        name: "POSTURE COMFORT",
        link: "/luxury-collection/posture-comfort/",
        startingAt: "₹26,599",
      },
      {
        img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Posture-Therapy-PT-1.png",
        name: "POSTURE THERAPY",
        link: "/luxury-collection/posture-therapy/",
        startingAt: "₹24,799",
      },
      {
        img: "https://eclipsemattress.in/wp-content/uploads/2021/06/1000X667-2.png",
        name: "POSTURE CARE",
        link: "/luxury-collection/posture-care/",
        startingAt: "₹23,899",
      },
    ],

    brochureLink:
      "https://eclipsemattress.in/assets/pdfs/Patent-&-Luxury-Catalogue.pdf",
    banner: "https://eclipsemattress.in/assets/images/banners/luxury-d.jpg",
    bannerSm: "https://eclipsemattress.in/assets/images/banners/luxury-m.jpg",
  };
  return (
    <div>
      <SEO
        title="Best Luxury Mattress in India | Eclipse International"
        description="Eclipse International has designed luxury mattresses that provides high back support with unique benefits. Made with plush fabric and premium border designs, the collection is heaven for a sleeper's body. Check out the wide range of collection"
      />
      <ProductCategory category={data} />
    </div>
  );
}
